import {
  TOGGLE_NOTEBOOK_COLLAPSE,
  SET_NOTEBOOK_SECTION,
  SET_NEW_CURRENT_PROTOCOL_SLIDE
} from '../../Redux.constants';
import {
  toggleNotebookCollapse,
  setNewNotebookSection,
  setNewDesignSlide
} from './Helpers';

export function NoteBookReducer(state={}, action) {
  switch (action.type) {
    case TOGGLE_NOTEBOOK_COLLAPSE:
      return toggleNotebookCollapse(state, action.payload);
    case SET_NOTEBOOK_SECTION:
      return setNewNotebookSection(state, action.payload);
    case SET_NEW_CURRENT_PROTOCOL_SLIDE:
      return setNewDesignSlide(state, action.payload);
    default:
      return state;
  }
}